import React from 'react';
import styled from 'styled-components';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
export const PageTitle = (props) => {
    const { children, image } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(STitleArea, null,
            image && React.createElement(SAvatar, { src: image, alt: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u753B\u50CF" }),
            React.createElement(STitle, null, children)),
        React.createElement(Divider, { style: { marginTop: '12px' } })));
};
const STitleArea = styled.div `
  display: flex;
  align-items: center;
`;
const STitle = styled.p `
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 0;
`;
const SAvatar = styled(Avatar) `
  &&& {
    width: 60px;
    height: 60px;
    margin-right: 16px;
  }
`;
